const setSelectedSearchBy = (state, payload) => {
  state.search.searchBy = payload
}

export default {
  setSelectedSearchBy,
}
